import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import type { Placement } from 'client-site-chrome-ui/types/locale';
import { setEventCategory } from 'client-site-chrome-ui/utils/setEventCategory';

export const sendToggleModalEvent = (isOpen: boolean, placement: Placement) =>
  sendGAEvent({
    event: 'custom_event',
    event_action: 'Change currency/location click',
    event_category: setEventCategory(placement),
    event_label: `${isOpen ? 'open' : 'close'} modal`,
  });
